import React from 'react';
import { formatDateTime } from './misc.jsx';

export default function Author(props: { timestamp: string }) {
  return (
    <div className="author">
      <img className="avatar" src="/shahab-sean-shirazi-small.jpg" />
      <div className="right">
        <h3 className="heading">Shahab (Sean) Shirazi</h3>
        <div className="time">{formatDateTime(new Date(props.timestamp))}</div>
        <p className="description">
          Founder of Computing Den | Software Engineer
          <br />
          Connect on{' '}
          <a href="https://www.linkedin.com/in/sean-shirazi" target="_blank" className="styled">
            LinkedIn
          </a>{' '}
          and{' '}
          <a href="https://x.com/SeanShirazi" target="_blank" className="styled">
            𝕏
          </a>
          .
        </p>
      </div>
    </div>
  );
}
